import { gql } from '@apollo/client'

export const EXPORT_PROCESSED_INGREDIENTS_QUERY = gql`
  query TaxonomyProcessedFunctionalUnits(
    $first: Int
    $after: String
    $where: TaxonomyProcessedIngFunctionalUnitsGraphQLFilterInput
    $order: [TaxonomyProcessedIngFunctionalUnitsGraphQLSortInput!]
  ) {
    taxonomyProcessedFunctionalUnits(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        name
        code
        state
        activity
        category
        subcategory
        functionalUnit
        functionalUnitAliases
        transportCondition
        isTransportAirFreight
        upstreamIngredientType
        upstreamIngredient
        faoTradeId
        faoTrade
        faoTradeSource
        faoProduction
        faoProductionId
        faoProductionSource
        isVerified
        verificationComments
        verifiedByName
        verifiedByEmail
        verifiedOn
        lastPublishedDate
        lastUpdatedName
        updated
        researcherName
        researcherEmail
        created
        userEmail
        produceSubcategoryId
        activityId
        upstreamIngredientId
        storageFoodCategory
        storageDurationInHours
        secondaryDataReferenceSourceType
        referenceAuthorName
        referenceLink
        storageReferenceLink
        referencesSamplingYear
        referenceDataPublicationYear
        referenceSourcingCountry
        dataQualityComment
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
